import { $, $$ } from '../../../shared/js/utils/dom';
import { Shower } from '../../../shared/js/modules/shower';
import { generateRandomString } from '../../../shared/js/utils/unique-string';

const accordions = $$('.accordion');

class Accordion {
  constructor(params) {
    this.el = params.el;
    this.items = $$('.accordion__item', this.el);
    this.showerInstances = [];
  }

  init = () => {
    this.items.forEach(item => {
      const handler = $('.accordion__button', item);
      const target = $('.accordion__content', item);

      this.setupAriaAttributes(handler, target);
      const itemShower = new Shower({ handler, target, duration: 300 });
      this.showerInstances.push(itemShower);
      itemShower.init();
    });
  };

  generateRandomId = el => {
    return Math.floor(
      Math.random() * Math.floor(Math.random() * Date.now() * el.offsetTop)
    );
  };

  setupAriaAttributes = (toggle, content) => {
    const uniqueId = `accordion-item-${generateRandomString(toggle.offsetTop)}`;
    toggle.setAttribute('aria-controls', uniqueId);
    content.setAttribute('id', uniqueId);
  };
}

accordions.forEach(accordion => {
  const accordionInstance = new Accordion({
    el: accordion,
  });
  accordionInstance.init();
});
